import { render, staticRenderFns } from "./StInfobox.vue?vue&type=template&id=0a309e19"
import script from "./StInfobox.vue?vue&type=script&lang=ts"
export * from "./StInfobox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports